module.exports = __webpack_public_path__ + "img/blue_045.ec2de84a.png";